import { ucfirst } from '@df/util/fn/ucfirst.fn';
import { NICmsContentField } from '@icms/core/content';
import { IPageComponentProductCarouselData } from '../products-carousel/products-carousel.component';
import { EModelCarouselVariant, IModelCarouselData } from './model-carousel.interface';

export function getFields(type: 'product' | string, qty = 36, pageType?: string): NICmsContentField.IField[] {
    // let filter;

    // if (pageType) {
    //     filter = { pageType };
    // }

    return [
        // header
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.label,
            key: 'section-header',
            title: 'Header',
            canShow: (data: IPageComponentProductCarouselData) => data['carouselVariant'] !== 'new_in'
        },
        <NICmsContentField.IField>{
            key: 'title',
            type: NICmsContentField.EFieldType.text,
            title: 'Title',
            canShow: (data: IPageComponentProductCarouselData) => data['carouselVariant'] !== 'new_in'
        },
        // content
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.label,
            key: 'section-content',
            title: 'Content'
        },
        <NICmsContentField.IChoiceField>{
            key: 'variant',
            required: true,
            type: NICmsContentField.EFieldType.choice,
            title: 'Source type',
            options: [
                { value: EModelCarouselVariant.ModelsIds, key: EModelCarouselVariant.ModelsIds, title: ucfirst(type) + ' selection' },
                type === 'product'
                    ? {
                          key: EModelCarouselVariant.CategoryProducts,
                          value: EModelCarouselVariant.CategoryProducts,
                          title: 'Category Selection'
                      }
                    : undefined
            ].filter(i => !!i),
            default: type === 'product' ? EModelCarouselVariant.CategoryProducts : EModelCarouselVariant.ModelsIds
        },
        <NICmsContentField.IRelationField>{
            key: 'category_id',
            type: NICmsContentField.EFieldType.relation,
            title: 'Category',
            options: {
                title: 'Catoegory',
                type: 'category',
                qty: 1
            },
            canShow: (data: IModelCarouselData) => data.variant === EModelCarouselVariant.CategoryProducts
        },
        <NICmsContentField.INumberField>{
            key: 'limit',
            type: NICmsContentField.EFieldType.number,
            title: 'Items Limit',
            description: 'Max number of items that can be displayed',
            default: qty,
            min: 1,
            max: qty,
            canShow: (data: IModelCarouselData) => data.variant === EModelCarouselVariant.CategoryProducts
        },
        <NICmsContentField.IRelationField>{
            key: 'ids',
            type: NICmsContentField.EFieldType.relation,
            title: 'Items',
            options: {
                title: 'Item',
                type,
                // filter,
                qty,
                multiple: true
            },

            canShow: (data: IModelCarouselData) => data.variant === EModelCarouselVariant.ModelsIds
        }
    ];
}

// export const config = <ICmsComponentMetaDeclared>{
//     id: 'product-carousel',
//     name: 'Product Carousel',
//     description: 'Standard carousel',
//     tags: ['images', 'carousel', 'slider', 'product'],
//     isLayout: true,
//     fields
// };
